import { Box, Popover, TextField } from "@mui/material";
import * as React from "react";

import { usePopupState } from "@/shared/hooks/usePopupState";

export type ColumnFilterPopoverProps = {
  popup: ReturnType<typeof usePopupState<void>>;
  filter: string;
  changeFilter: (filter: string) => void;
};

/**
 * A popover textfield used to apply a column filter to the log panel.
 *
 * This component is used both in the table header and in the
 * search input field.
 */
export function ColumnFilterPopover({
  popup,
  filter,
  changeFilter,
}: ColumnFilterPopoverProps) {
  const textFieldRef = React.useRef<HTMLInputElement>();
  return (
    <Popover
      disableRestoreFocus
      disableAutoFocus
      open={popup.isOpen}
      anchorEl={popup.anchor}
      onClose={() => popup.close()}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <Box sx={{ p: 2, minWidth: 200 }}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            popup.close();
          }}
        >
          <TextField
            inputRef={textFieldRef}
            autoFocus
            fullWidth
            size="small"
            placeholder="Filter this column"
            variant="outlined"
            value={filter}
            onChange={(event) => {
              changeFilter(event.target.value);
            }}
          />
        </form>
      </Box>
    </Popover>
  );
}
